export const IMAGE_BLUR_DATA_URL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNcYGFfDwAELwGYQcAc1gAAAABJRU5ErkJggg==';

export const HEADER_FOOTER_TYPES = {
  global: 'global',
  checkout: 'checkout',
  hidden: 'hidden',
};

export const DEFAULT_COUNTRY = 'India';

export const STORAGE_KEYS = {
  CART_ID: 'cart_id',
  BILLING_ADDRESS: 'billing_address',
  SHIPPING_ADDRESS: 'shipping_address',
  DELIVERY_METHOD: 'delivery_method',
  PINCODE: 'pincode',
};

export const PRIVATE_ROUTES = {
  account: '/account',
};

export const COUNTRY_CODE = '+91';
export const LANDLINE_NUMBER =
  process.env.NEXT_PUBLIC_CALL_NUMBER ?? '9004171401';
export const LANDLINE_NUMBER_2 =
  process.env.NEXT_PUBLIC_CALL_NUMBER_2 ?? '7718055496';
export const WHATSAPP_NUMBER =
  process.env.NEXT_PUBLIC_WHATSAPP_NUMBER ?? '9004171401';
export const EMAIL_ID_SUPPORT =
  process.env.NEXT_PUBLIC_SUPPORT_EMAIL ?? 'care@foodstories.shop';
export const FACEBOOK_URL =
  process.env.NEXT_PUBLIC_FACEBOOK_URL ??
  'https://www.facebook.com/yourfoodstories.in/';
export const INSTAGRAM_URL =
  process.env.NEXT_PUBLIC_INSTAGRAM_URL ??
  'https://www.instagram.com/yourfoodstories.in/';
export const YOUTUBE_URL =
  process.env.NEXT_PUBLIC_YOUTUBE_URL ??
  'https://www.youtube.com/c/FoodhallIndia';
export const VASANT_KUNJ_LOCATION_URL =
  process.env.NEXT_PUBLIC_VASANT_KUNJ_LOCATION_URL ??
  'https://maps.app.goo.gl/Bm5ipJ5gQ1xsUgN59';
export const BANJARA_HILLS_LOCATION_URL =
  process.env.NEXT_PUBLIC_BANJARA_HILLS_LOCATION_URL ??
  'https://maps.app.goo.gl/L7kZeuffZvEwZDUK8';
export const BASE_FE_URL =
  process.env.BASE_FE_URL ?? 'https://www.foodstories.shop';

export enum PRODUCT_LAYOUT_ENUMS {
  cart = 'cart',
  summary = 'summary',
  studioSummary = 'studio-summary',
  eventsSummary = 'events-summary',
  studioOrderStatus = 'studio-order-status',
}

export const RECIPE_CARD_TAGS = ['cuisine', 'skill_level_tags'];
export const GENERIC_ERROR_MESSAGE = 'Something went wrong!, Please try again.';
export const NEWSLETTER_SUCCESS_MESSAGE =
  'Thanks for subscribing to the newsletter';
export const RUPEE_SYMBOL = '₹';
export const OUT_OF_STOCK = 'Out of Stock';
export const OUT_OF_STOCK_LABEL = 'Sold Out';

export const FORM_SUBMITTED = 'submitted';
export const BREADCRUMB = 'breadcrumb';
export const NO_SELECTION = 'no_selection';

export const PROUDCT_ATTRIBUTE_SETS_ENUMS = {
  default: 'default',
  giftHampers: 'gift hampers',
  giftCard: 'gift card',
  recipes: 'recipes',
  bento: 'bento',
  storiesArticle: 'stories-article',
  storiesListicle: 'stories-listicle',
  storiesHierarchical: 'stories-hierarchical',
  storiesHierarchicalChild: 'stories-hierarchical-child',
};

export const MENU_LINKS = {
  SHOP: '/shop',
  STORIES: '/stories',
  RECIPES: '/recipes',
  CONTACT_US: '/contact-us',
  FAQS: '/faqs/shopping-at-foodstories',
  KITCHEN_STUDIO: '/kitchen-studio',
  GIFTING: '/gifting',
  RAMZAN_GIFTING: '/ramzan-gifting',
  BULK_GIFTING: '/bulk-gifting',
  MANGO_GIFTING: '/mango-gifting',
  FATHERS_DAY: '/fathers-day',
};

export const REVALIDATE_TIME = process.env.REVALIDATE_TIME
  ? Number(process.env.REVALIDATE_TIME)
  : 3600;

export const OUT_OF_STOCK_CODE = 0;

export const BANNER_IMAGES_CODES = {
  home: {
    hero: 'home-hero-banner',
  },
  recipes: {
    hero: 'recipes-hero-banner',
    cwy: 'recipe-cwy',
  },
  gifting: {
    landing: 'gift-landing',
    form: 'gifting-form',
    hero: 'gifting-hero-banner',
    buildYourOwnBox: 'build-your-own-box',
    pdp: 'gifting-pdp-middle-banner',
  },
  mangoGifting: {
    hero: 'mango-special-page-banner',
    default: 'mango-gifting',
  },
  bulkGifting: {
    hero: 'bulk-gifting-form-page',
  },
  mothersDay: {
    hero: 'mothers-day-special-banner',
  },
};

export const CITY_DATA = [{ name: 'Delhi', value: 'Delhi' }];

export const STORE_DATA = [
  { name: 'Ambience Mall, Vasant Kunj, Delhi', value: '1' },
];

export const TIME_SLOT_DATA = [
  { name: '10.00 AM - 01.30 PM', value: '10.00 AM - 01.30 PM' },
  { name: '01.30 PM - 05.00 PM', value: '01.30 PM - 05.00 PM' },
  { name: '05.00 PM - 08.30 PM', value: '05.00 PM - 08.30 PM' },
];

export const PLATTER_ELEMENTS_DATA = [
  {
    id: 0,
    label: 'Cheese',
    value: 'Cheese',
  },
  {
    id: 1,
    label: 'Fruits',
    value: 'Fruits',
  },
  {
    id: 2,
    label: 'Crackers',
    value: 'Crackers',
  },
  {
    id: 3,
    label: 'Meat',
    value: 'Meat',
  },
  {
    id: 4,
    label: 'Bread',
    value: 'Bread',
  },
  {
    id: 5,
    label: 'Dry Fruits & Nuts',
    value: 'Dry Fruits & Nuts',
  },
];

export const HAMPER_OPTIONS = [
  { name: 'Cheese Hampers', value: 'Cheese Hampers' },
  { name: 'Chocolate Hampers', value: 'Chocolate Hampers' },
  {
    name: 'Dry Fruit, Nuts and Honey Hampers',
    value: 'Dry Fruit, Nuts and Honey Hampers',
  },
];

export const GURUGRAM_STORE_CODE = 'gurugram';
export const HYDRABAD_STORE_CODE = 'hyderabad';

export const STORE_CODE_CITY_MAP = {
  vasantkunj: 'Delhi NCR',
  hyderabad: 'Hyderabad',
  bengaluru: 'Bengaluru',
};

export const MANGO_TYPE_OPTIONS = [
  { name: 'Alphonso', value: 'Alphonso' },
  { name: 'Himayat', value: 'Himayat' },
  { name: 'Panduri', value: 'Panduri' },
  { name: 'Kotthaplli Kobbari ', value: 'Kotthaplli Kobbari ' },
  { name: 'Kesar', value: 'Kesar' },
  { name: 'Diversity Box', value: 'Diversity Box' },
  { name: 'Others', value: 'Others' },
];

export const CONTENT_TYPE_OPTIONS = [
  { name: 'Article', value: 'Article' },
  { name: 'Listicle', value: 'Listicle' },
  { name: 'Recipe', value: 'Recipe' },
];

export const STORIES_TYPE = {
  HIERARCHICAL: 'stories-hierarchical',
  HIERARCHICAL_CHILD: 'stories-hierarchical-child',
  LISTICLE: 'stories-listicle',
  ARTICLE: 'stories-article',
};

export const GIFT_MESSAGE_RADIO_GROUP = [
  {
    title: 'Use the same message',
    subTitle: 'All your gifts will be sent with the same message and card.',
    value: 'sameMessage',
  },
  {
    title: 'Use different messages',
    subTitle:
      'Add different messages and cards to different gifts you have chosen.',
    value: 'differentMessage',
  },
];

export const STORY_DESCRIPTION_SECTION_COUNT = {
  ARTICLE: 15,
  LISTICLE: 15,
};

export const GIFTING_SUB_CATEGORIES = {
  CATEGORY_1: 'gift-a-story',
  CATEGORY_2: 'gifts-by-type',
};

export const PAGE_TYPE = {
  SHOP: 'shop',
  RECIPES: 'recipes',
  GIFTING: 'gifting',
  SEARCH_RESULTS: 'search-results',
};

export const COD_ENABLED = process.env.NEXT_PUBLIC_ENABLE_COD === 'true';

export const GIFTING_PLP_PAGINATION_SIZE = '30';

export const DELIVERY_REDUCTION_AMOUNT = 1250;

export const WIZZY_CONSTANTS = {
  FACETS: {
    CATEGORIES: 'categories',
    LIFESTYLE: 'lifestyle',
    TEXTURE: 'texture',
    FLAVOUR: 'flavour',
    SKILL: 'skill_level_tag',
    CUISINE: 'cuisine',
    ADDITIONAL_FILTERS: 'additional_filters',
    PRICE: 'sellingPrice',
    HALAL: 'nvpl_halal_tag',
    CHOICE_OF_MEAT: 'nvpl_meat_type',
    ORIGIN: 'nvpl_origin',
    PREPARATION: 'nvpl_preparation_type',
  },
  FACETS_VALUE_LIMIT: 20,
  FILTER_REQUEST_TYPE: {
    DEFAULT: 'DEFAULT',
    CATEGORY_PAGE: 'CATEGORY_PAGE',
  },
  SORT: {
    FINAL_PRICE: 'finalPrice',
    SELLING_PRICE: 'sellingPrice',
    NAME: 'name',
  },
  SORT_OPTIONS: {
    DEFAULT: [
      {
        field: 'relevance',
        order: 'asc',
      },
      { field: 'is_hero_product', order: 'desc' },
      {
        field: 'inStock',
        order: 'asc',
        isForParent: true,
        isForVariation: true,
      },
      {
        field: 'sellingPrice',
        order: 'asc',
        isForParent: false,
        isForVariation: true,
      },
    ],
    SELLING_PRICE: {
      ASCENDING: [
        {
          field: 'inStock',
          order: 'asc',
          isForParent: true,
          isForVariation: true,
        },
        {
          field: 'sellingPrice',
          order: 'asc',
          isForParent: true,
          isForVariation: true,
        },
      ],
      DESCENDING: [
        {
          field: 'inStock',
          order: 'asc',
          isForParent: true,
          isForVariation: true,
        },
        {
          field: 'sellingPrice',
          order: 'desc',
          isForParent: true,
          isForVariation: true,
        },
      ],
    },
    NAME: {
      ASCENDING: [
        {
          field: 'name',
          order: 'asc',
        },
        {
          field: 'inStock',
          order: 'asc',
          isForParent: true,
          isForVariation: true,
        },
        {
          field: 'sellingPrice',
          order: 'asc',
          isForParent: false,
          isForVariation: true,
        },
      ],
      DESCENDING: [
        {
          field: 'name',
          order: 'desc',
        },
        {
          field: 'inStock',
          order: 'asc',
        },
        {
          field: 'sellingPrice',
          order: 'asc',
          isForParent: false,
          isForVariation: true,
        },
      ],
    },
  },
};

export const FILTER_LABELS = {
  CATEGORIES: 'Filter By Category',
  LIFESTYLE: 'Filter By Lifestyle',
  TEXTURE: 'Filter By Texture',
  FLAVOUR: 'Filter By Flavour',
  SKILL: 'Filter By Skill',
  CUISINE: 'Filter By Cuisine',
  ADDITIONAL_FILTERS: 'Food Origin',
  NONVEG_POPULARITY_TAG: 'Non-Veg Popularity Tag',
};

export const ALLOWED_REGIONS = ['DL', 'HR', 'UP', 'TG', 'KA'];

export const TOKEN_EXPIRY_TIME =
  Number(process.env.TOKEN_EXPIRY_TIME) || 2592000;

export const DEFAULT_STORE_CODE =
  process.env.DEFAULT_STORE_CODE || 'vasantkunj';

export const DEFAULT_STORE_ADDRESS =
  process.env.NEXT_PUBLIC_DEFAULT_STORE_ADDRESS ||
  'Foodstories, G-01, Lower Ground Floor, Ambience Mall, Vasant Kunj';

export const DEFAULT_STOCK_ID = process.env.DEFAULT_STOCK_ID || '1';

export const MAGENTO_GRAPHQL_CAROUSEL_TYPES: any = {
  HOMEPAGE: 'home_page',
  TRENDING_PRODUCTS: 'trending_products',
  CART_RECOMMENDATIONS: 'cart_recommendations',
  GIFTING: 'gifting',
  ADDITIONAL: 'additional',
};

export const STORE_CODES = ['vasantkunj', 'hyderabad', 'bengaluru'];

export const STORE_REGION_ID_MAP = {
  '110000': 'vasantkunj',
  '500000': 'hyderabad',
  '560000': 'bengaluru',
};

export const STOCKID_REGION_ID_MAP = {
  '110000': '1',
  '500000': '2',
  '560000': '3',
};

export const GIFTING_MESSAGE_ALLOWED_CHARS = new Set([
  '.',
  '!',
  '~',
  '@',
  '#',
  '%',
  '(',
  ')',
  '-',
  '_',
  '+',
  '=',
  '{',
  '}',
  '[',
  ']',
  ':',
  ';',
  "'",
  ',',
  '/',
  ' ',
]);

export const PaymentOptions = [
  {
    id: 'upi',
    name: 'UPI',
    logo: '/images/global/PaymentOptions/Upi.png',
  },
  { id: 'gpay', name: 'GPAY', logo: '/images/global/PaymentOptions/Gpay.png' },
  {
    id: 'phonepe',
    name: 'PHONEPE',
    logo: '/images/global/PaymentOptions/PhonePe.png',
  },
  {
    id: 'paytm',
    name: 'PAYTM',
    logo: '/images/global/PaymentOptions/Paytm.png',
  },

  { id: 'visa', name: 'VISA', logo: '/images/global/PaymentOptions/Visa.png' },
];

export const GIFTING_BUILD_YOUR_OWN_BOX_PATH_STEPS = [
  '/gifting/build-your-own-box/select-box/',
  '/gifting/build-your-own-box/add-items/',
  '/gifting/build-your-own-box/personalize/',
  '/gifting/build-your-own-box/summary/',
];
